export const PreLineHex: string = '#f3cc50'
